export function TopItemCard({ rank, title, subtitle, value, imageUrl }) {
  return (
    <div className="flex items-center gap-4 p-3 bg-white/5 rounded-lg hover:bg-white/10 transition-all">
      <div className="w-8 h-8 rounded-full bg-purple-500/30 flex items-center justify-center font-bold text-purple-300">
        {rank}
      </div>
      {imageUrl && (
        <img src={imageUrl} alt={title} className="w-12 h-12 rounded-lg object-cover" />
      )}
      <div className="flex-1 min-w-0">
        <p className="font-medium truncate">{title}</p>
        {subtitle && <p className="text-sm text-gray-400 truncate">{subtitle}</p>}
      </div>
      <div className="text-right">
        <p className="font-semibold text-purple-400">{value}</p>
      </div>
    </div>
  );
}
